import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchUserDetail } from "services/apis";


const initialState = {
  userDetail: [], 
  status: "idle", 
  loading: false,
  error: null,
};


export const getusersDetail = createAsyncThunk(
  "users/fetchusersDetail",
  async (data, { rejectWithValue }) => {
    try {
      const response = await fetchUserDetail(data); 
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch users detail");
    }
  }
);


const userDetailSlice = createSlice({
  name: "usersDetail",
  initialState,
  reducers: {
    
  },
  extraReducers: (builder) => {
    builder
      .addCase(getusersDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.status = "loading";
      })
      .addCase(getusersDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.userDetail = action.payload; 
        state.status = "succeeded";
      })
      .addCase(getusersDetail.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.payload; 
      });
  },
});

export default userDetailSlice.reducer;